'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _UITooltip = require('../tooltip/UITooltip');

var _UITooltip2 = _interopRequireDefault(_UITooltip);

var _Overflows = require('../utils/Overflows');

var _Timers = require('../utils/Timers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UITruncateString = function (_PureComponent) {
  _inherits(UITruncateString, _PureComponent);

  function UITruncateString(props) {
    _classCallCheck(this, UITruncateString);

    var _this = _possibleConstructorReturn(this, (UITruncateString.__proto__ || Object.getPrototypeOf(UITruncateString)).call(this, props));

    _this.state = {
      contentWidth: undefined,
      isTruncated: null
    };

    _this.updateTruncatedState = _this.updateTruncatedState.bind(_this);
    _this.delayedUpdateTruncatedState = _this.delayedUpdateTruncatedState.bind(_this);
    _this.wrapperRefCallback = _this.wrapperRefCallback.bind(_this);
    _this.contentRefCallback = _this.contentRefCallback.bind(_this);
    _this.tailRefCallback = _this.tailRefCallback.bind(_this);

    _this._key = 0;
    return _this;
  }

  _createClass(UITruncateString, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this._key = 0;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.matchContentWidth || this.props.reverse) {
        this.updateTruncatedState();
      } else {
        this.delayedUpdateTruncatedState();
      }
      window.addEventListener('resize', this.delayedUpdateTruncatedState);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // Workaround for a truly bizarre Safari bug (#5825)
      var hasMaxWidth = this.props.maxWidth != null;
      var willHaveMaxWidth = nextProps.maxWidth != null;
      if (hasMaxWidth !== willHaveMaxWidth) {
        this._key = this._key + 1;
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      // ⚠️ This condition prevents infinite loops! ⚠️
      if (prevState.contentWidth === this.state.contentWidth && prevState.isTruncated === this.state.isTruncated) {
        this.delayedUpdateTruncatedState();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.delayedUpdateTruncatedState);
      (0, _Timers.cancelSchedulerCallback)(this._timeout);
    }
  }, {
    key: 'updateTruncatedState',
    value: function updateTruncatedState() {
      // If the last render was caused by updateTruncatedState(), we have nothing to do.
      var wrapperEl = this._wrapperEl;
      var contentEl = this._contentEl;
      if (!wrapperEl || !contentEl) {
        return;
      }
      var _props = this.props,
          matchContentWidth = _props.matchContentWidth,
          reverse = _props.reverse;

      var contentWidth = void 0;
      if (matchContentWidth) {
        // We need to temporarily make the content `display: inline-block` for the width calculation.
        contentEl.style.display = 'inline-block';
        contentWidth = contentEl.clientWidth + 1;
        contentEl.style.display = '';
      }

      var isTruncated = void 0;
      if (reverse) {
        var tailEl = this._tailEl;
        if (!tailEl) {
          return;
        }
        isTruncated = (0, _Overflows.overflowsX)(tailEl, wrapperEl);
      } else {
        isTruncated = (0, _Overflows.overflowsX)(wrapperEl);
      }
      if (contentWidth !== this.state.contentWidth || isTruncated !== this.state.isTruncated) {
        this.setState({ contentWidth: contentWidth, isTruncated: isTruncated });
      }
    }
  }, {
    key: 'delayedUpdateTruncatedState',
    value: function delayedUpdateTruncatedState() {
      (0, _Timers.cancelSchedulerCallback)(this._timeout); // Ensure only one callback is queued at a time
      this._timeout = (0, _Timers.requestSchedulerCallback)(this.updateTruncatedState);
    }
  }, {
    key: 'wrapperRefCallback',
    value: function wrapperRefCallback(ref) {
      this._wrapperEl = ref;
    }
  }, {
    key: 'contentRefCallback',
    value: function contentRefCallback(ref) {
      this._contentEl = ref;
    }
  }, {
    key: 'tailRefCallback',
    value: function tailRefCallback(ref) {
      this._tailEl = ref;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          children = _props2.children,
          className = _props2.className,
          fixedChildren = _props2.fixedChildren,
          innerClassName = _props2.innerClassName,
          __matchContentWidth = _props2.matchContentWidth,
          maxWidth = _props2.maxWidth,
          placement = _props2.placement,
          reverse = _props2.reverse,
          tooltip = _props2.tooltip,
          useFlex = _props2.useFlex,
          rest = _objectWithoutProperties(_props2, ['children', 'className', 'fixedChildren', 'innerClassName', 'matchContentWidth', 'maxWidth', 'placement', 'reverse', 'tooltip', 'useFlex']);

      var _state = this.state,
          contentWidth = _state.contentWidth,
          isTruncated = _state.isTruncated;


      var computedClassName = (0, _classNames2.default)('private-truncated-string', className, {
        'private-truncated-string--is-flex': useFlex,
        'private-truncated-string--has-tooltip': Boolean(isTruncated)
      });

      // When maxWidth is set, we need to set maxWidth on both the outer container and the inner
      // wrapper. We also need to set width to "unset" (if we aren't using matchContentWidth) in
      // order to prevent the table column from collapsing to 0 due to the `width: 100%` rule.
      var computedMaxWidth = maxWidth && contentWidth ? Math.min(maxWidth, contentWidth) : maxWidth || contentWidth;
      var style = computedMaxWidth ? {
        maxWidth: computedMaxWidth,
        width: maxWidth ? 'unset' : undefined
      } : undefined;

      var tailClassName = (0, _classNames2.default)('private-truncated-string__reverse__tail', {
        'is-truncated': isTruncated
      });

      var renderedContent = reverse ? _react2.default.createElement(
        'span',
        { className: 'private-truncated-string__reverse' },
        isTruncated ? _react2.default.createElement(
          'span',
          { className: 'private-truncated-string__reverse__ellipse' },
          '\u2026'
        ) : null,
        _react2.default.createElement(
          'span',
          { className: tailClassName },
          _react2.default.createElement(
            'span',
            {
              className: 'private-truncated-string__reverse__content',
              ref: this.tailRefCallback
            },
            children
          )
        )
      ) : children;

      return _react2.default.createElement(
        _UITooltip2.default,
        {
          disabled: tooltip === false || isTruncated === false,
          placement: placement,
          title: typeof tooltip === 'boolean' ? children : tooltip
        },
        _react2.default.createElement(
          'span',
          _extends({}, rest, {
            className: computedClassName,
            key: this._key,
            style: style
          }),
          _react2.default.createElement(
            'span',
            {
              className: (0, _classNames2.default)('private-truncated-string__inner', innerClassName),
              ref: this.wrapperRefCallback,
              style: style
            },
            _react2.default.createElement(
              'span',
              { ref: this.contentRefCallback },
              renderedContent
            )
          ),
          fixedChildren
        )
      );
    }
  }]);

  return UITruncateString;
}(_react.PureComponent);

exports.default = UITruncateString;


UITruncateString.propTypes = {
  children: _react.PropTypes.node.isRequired,
  fixedChildren: _react.PropTypes.node,
  innerClassName: _react.PropTypes.string,
  matchContentWidth: _react.PropTypes.bool.isRequired,
  maxWidth: _react.PropTypes.number,
  placement: _UITooltip2.default.propTypes.placement,
  reverse: _react.PropTypes.bool.isRequired,
  tooltip: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.node, _react.PropTypes.string]).isRequired,
  useFlex: _react.PropTypes.bool.isRequired
};

UITruncateString.defaultProps = {
  placement: _UITooltip2.default.defaultProps.placement,
  reverse: false,
  tooltip: true,
  matchContentWidth: false,
  useFlex: false
};

UITruncateString.displayName = 'UITruncateString';
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2644/js/text/UITruncateString.js
// module id = 197
// module chunks = 3 4 5